import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';

import {HtmlSeguroPipe} from "./HtmlSeguro.pipe";
import {FiltroPipe} from './Filtro.pipe';
import {ImagenPipe} from './Imagen.pipe';
import {Base64SeguroPipe} from './Base64Seguro.pipe';
import {SeleccionarDiponiblePipe} from './SeleccionarDiponible.pipe';
import {GetCatalogoDeCatalgoPipe} from './GetCatalogoDeCatalgo.pipe';
import { FiltroArrayPipe } from './FiltroArray.pipe';

@NgModule({
    declarations:
        [
            HtmlSeguroPipe,
            FiltroPipe,
            FiltroArrayPipe,
            ImagenPipe,
            Base64SeguroPipe,
            SeleccionarDiponiblePipe,
            GetCatalogoDeCatalgoPipe
        ],
    imports:
        [
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
        ],
    exports:
        [
            HtmlSeguroPipe,
            FiltroPipe,
            FiltroArrayPipe,
            ImagenPipe,
            Base64SeguroPipe,
            SeleccionarDiponiblePipe,
            GetCatalogoDeCatalgoPipe
        ]
})

export class PipesModule {
    constructor() {

    }
}
